import React from 'react'
import { motion } from 'framer-motion'
import { fadeIn } from '../variants'
import { BiBriefcase } from 'react-icons/bi';
import { FaGraduationCap } from 'react-icons/fa';
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
import TimelineDot from '@mui/lab/TimelineDot';
import Typography from '@mui/material/Typography';
import Logo_EasyStore from '../assets/logo_easystore.webp'
import Logo_Iot from '../assets/logo_iotadvance.png'
import Logo_E73 from '../assets/logo_e73.webp'
import Logo_QIU from '../assets/logo_qiu.jpg'
import Logo_Nexmind from '../assets/logo_nexmind.png'
import Logo_QUT from '../assets/logo_QUT.png'
import Logo_HH_nib from '../assets/logo_HH-nib.png'



const Work = () => {
  return (
    <section id='work' className='xl:h-[860px] py-12 xl:py-24 mb-20'>
      <div className='container mx-auto hidden lg:block'>
        <motion.h2
          variants={fadeIn('down', 0.4)}
          initial="hidden"
          whileInView={'show'}
          viewport={{ once: true, amount: 0.1 }}
          className='h2 text-accent text-center mx-auto'>Academic and Work Experience.</motion.h2>
        <motion.div
          variants={fadeIn('up', 0.4)}
          initial="hidden"
          whileInView={'show'}
          viewport={{ once: true, amount: 0.4 }}
          className="experience flex">
          <Timeline position="alternate">
            <TimelineItem>
              <TimelineOppositeContent
                sx={{ m: 'auto 0' }}
                variant="body2"
                color="text.white">
                <motion.div
                  variants={fadeIn('left', 0.7)}
                  initial="hidden"
                  whileInView={'show'}
                  viewport={{ once: true, amount: 0.7 }}>
                  Nov 2025 - May 2026
                </motion.div>
              </TimelineOppositeContent>
              <TimelineSeparator>
                <TimelineConnector />
                <TimelineDot color="secondary">
                  <BiBriefcase />
                </TimelineDot>
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent sx={{ py: '12px', px: 2 }}>
                <motion.div
                  variants={fadeIn('right', 0.7)}
                  initial="hidden"
                  whileInView={'show'}
                  viewport={{ once: true, amount: 0.7 }}
                  className='bg-black/50 backdrop-blur-2xl py-4 px-10 rounded-full  flex items-center'>
                  <div>
                    <img src={Logo_HH_nib} alt="Honeysuckle Health" className='w-[200px] bg-[#fdf1fc] rounded-xl p-2' />
                  </div>
                  <div className='text-right flex-1 flex-col'>
                    <Typography variant="h6" component="span">
                      Software Engineer
                    </Typography>
                    <Typography>Honeysuckle Health (nib Group)<br /> - Brisbane, Australia</Typography>
                  </div>
                </motion.div>
              </TimelineContent>
            </TimelineItem>

            <TimelineItem>
              <TimelineOppositeContent
                sx={{ m: 'auto 0' }}
                variant="body2"
                color="text.white">
                <motion.div
                  variants={fadeIn('left', 0.7)}
                  initial="hidden"
                  whileInView={'show'}
                  viewport={{ once: true, amount: 0.7 }}>
                  Jul 2023 - Jul 2025 (Graduated)
                </motion.div>
              </TimelineOppositeContent>
              <TimelineSeparator>
                <TimelineConnector />
                <TimelineDot color="primary">
                  <FaGraduationCap />
                </TimelineDot>
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent sx={{ py: '12px', px: 2 }}>
                <motion.div
                  variants={fadeIn('right', 0.7)}
                  initial="hidden"
                  whileInView={'show'}
                  viewport={{ once: true, amount: 0.7 }}
                  className='bg-black/50 backdrop-blur-2xl py-4 px-10 rounded-full  flex items-center'>
                  <div>
                    <img src={Logo_QUT} alt="QUT" className='w-[80px]' />
                  </div>
                  <div className='text-right flex-1 flex-col'>
                    <Typography variant="h6" component="span">
                      Masters of Information Technology
                    </Typography>
                    <Typography>Queensland University of Technology (QUT) <br /> - Brisbane, Australia</Typography>
                  </div>
                </motion.div>
              </TimelineContent>
            </TimelineItem>

            <TimelineItem>
              <TimelineOppositeContent
                sx={{ m: 'auto 0' }}
                align="right"
                variant="body2"
                color="text.white">
                <motion.div
                  variants={fadeIn('right', 0.7)}
                  initial="hidden"
                  whileInView={'show'}
                  viewport={{ once: true, amount: 0.7 }}>
                  Mar 2023 - Aug 2023
                </motion.div>
              </TimelineOppositeContent>
              <TimelineSeparator>
                <TimelineConnector />
                <TimelineDot color="secondary" >
                  <BiBriefcase />
                </TimelineDot>
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent sx={{ py: '12px', px: 2 }}>
                <motion.div
                  variants={fadeIn('left', 0.7)}
                  initial="hidden"
                  whileInView={'show'}
                  viewport={{ once: true, amount: 0.7 }}
                  className='bg-black/50 backdrop-blur-2xl p-5 pl-10 pr-6 rounded-full flex items-center'>
                  <div className='text-left flex-1 flex-col'>
                    <Typography variant="h6" component="span">
                      Senior Front-End Developer
                    </Typography>
                    <Typography>Nexmind AI - Malaysia</Typography>
                  </div>
                  <div className='bg-about'>
                    <img src={Logo_Nexmind} alt="Nexmind" className='w-[50px] mr-5' />
                  </div>
                </motion.div>
              </TimelineContent>
            </TimelineItem>

            <TimelineItem>
              <TimelineOppositeContent
                sx={{ m: 'auto 0' }}
                variant="body2"
                color="text.white">
                <motion.div
                  variants={fadeIn('left', 0.7)}
                  initial="hidden"
                  whileInView={'show'}
                  viewport={{ once: true, amount: 0.7 }}>
                  May 2021 - Nov 2022
                </motion.div>
              </TimelineOppositeContent>
              <TimelineSeparator>
                <TimelineConnector />
                <TimelineDot color="secondary">
                  <BiBriefcase />
                </TimelineDot>
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent sx={{ py: '12px', px: 2 }}>
                <motion.div
                  variants={fadeIn('right', 0.7)}
                  initial="hidden"
                  whileInView={'show'}
                  viewport={{ once: true, amount: 0.7 }}
                  className='bg-black/50 backdrop-blur-2xl p-5 px-12 rounded-full flex items-center'>
                  <div>
                    <img src={Logo_EasyStore} alt="EasyStore" className='w-[80px]' />
                  </div>
                  <div className='text-right flex-1 flex-col'>
                    <Typography variant="h6" component="span">
                      Front-End Web Developer
                    </Typography>
                    <Typography>EasyStore - Malaysia</Typography>
                  </div>
                </motion.div>
              </TimelineContent>
            </TimelineItem>

            <TimelineItem>
              <TimelineOppositeContent
                sx={{ m: 'auto 0' }}
                align="right"
                variant="body2"
                color="text.white">
                <motion.div
                  variants={fadeIn('right', 0.7)}
                  initial="hidden"
                  whileInView={'show'}
                  viewport={{ once: true, amount: 0.7 }}>
                  Mar 2021 - Feb 2022
                </motion.div>
              </TimelineOppositeContent>
              <TimelineSeparator>
                <TimelineConnector />
                <TimelineDot color="secondary" >
                  <BiBriefcase />
                </TimelineDot>
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent sx={{ py: '12px', px: 2 }}>
                <motion.div
                  variants={fadeIn('left', 0.7)}
                  initial="hidden"
                  whileInView={'show'}
                  viewport={{ once: true, amount: 0.7 }}
                  className='bg-black/50 backdrop-blur-2xl p-5 pl-10 pr-6 rounded-full flex items-center'>
                  <div className='text-left flex-1 flex-col'>
                    <Typography variant="h6" component="span">
                      Front-End Web Developer (Freelance)
                    </Typography>
                    <Typography>IOT Advance - Malaysia</Typography>
                  </div>
                  <div className='bg-about'>
                    <img src={Logo_Iot} alt="IOT Advance" className='w-[90px]' />
                  </div>
                </motion.div>
              </TimelineContent>
            </TimelineItem>

            <TimelineItem>
              <TimelineOppositeContent
                sx={{ m: 'auto 0' }}
                variant="body2"
                color="text.white">
                <motion.div
                  variants={fadeIn('left', 0.7)}
                  initial="hidden"
                  whileInView={'show'}
                  viewport={{ once: true, amount: 0.7 }}>
                  Dec 2019 - Dec 2020
                </motion.div>
              </TimelineOppositeContent>
              <TimelineSeparator>
                <TimelineConnector />
                <TimelineDot color="secondary">
                  <BiBriefcase />
                </TimelineDot>
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent sx={{ py: '12px', px: 2 }}>
                <motion.div
                  variants={fadeIn('right', 0.7)}
                  initial="hidden"
                  whileInView={'show'}
                  viewport={{ once: true, amount: 0.7 }}
                  className='bg-black/50 backdrop-blur-2xl p-5 px-10 rounded-full  flex items-center'>
                  <div>
                    <img src={Logo_E73} alt="EasyStore" className='w-[150px]' />
                  </div>
                  <div className='text-right flex-1 flex-col'>
                    <Typography variant="h6" component="span">
                      Web Developer
                    </Typography>
                    <Typography>Enterprise 73 - Malaysia</Typography>
                  </div>
                </motion.div>
              </TimelineContent>
            </TimelineItem>

            <TimelineItem>
              <TimelineOppositeContent
                sx={{ m: 'auto 0' }}
                align="right"
                variant="body2"
                color="text.white">
                <motion.div
                  variants={fadeIn('right', 0.7)}
                  initial="hidden"
                  whileInView={'show'}
                  viewport={{ once: true, amount: 0.7 }}>
                  2015 - 2019
                </motion.div>
              </TimelineOppositeContent>
              <TimelineSeparator>
                <TimelineConnector />
                <TimelineDot color="primary">
                  <FaGraduationCap />
                </TimelineDot>
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent sx={{ py: '12px', px: 2 }}>
                <motion.div
                  variants={fadeIn('left', 0.7)}
                  initial="hidden"
                  whileInView={'show'}
                  viewport={{ once: true, amount: 0.7 }}
                  className='bg-black/50 backdrop-blur-2xl py-5 pl-10 pr-5 rounded-full flex items-center'>
                  <div className='text-left flex-1 flex-col'>
                    <Typography variant="h6" component="span">
                      Bachelor in Computer Science (HONs)
                    </Typography>
                    <Typography>Quest International University (QIU) - Malaysia</Typography>
                  </div>
                  <div className='bg-about pr-5'>
                    <img src={Logo_QIU} alt="QIU" className='w-[50px] mr-2 rounded' />
                  </div>
                </motion.div>
              </TimelineContent>
            </TimelineItem>










          </Timeline>
        </motion.div>

      </div>
      <div className='container mx-auto lg:hidden'>
        <motion.h2
          variants={fadeIn('down', 0.4)}
          initial="hidden"
          whileInView={'show'}
          viewport={{ once: true, amount: 0.1 }}
          className='h2 text-accent text-center mx-auto'>Academic and Work Experience.</motion.h2>
        <motion.div
          variants={fadeIn('up', 0.4)}
          initial="hidden"
          whileInView={'show'}
          viewport={{ once: true, amount: 0.4 }}
          className="experience flex">
          <Timeline position="right">
            <TimelineItem>
              <TimelineSeparator>
                <TimelineConnector />
                <TimelineDot color="secondary">
                  <BiBriefcase />
                </TimelineDot>
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent sx={{ py: '12px', px: 2 }}>
                <motion.div
                  variants={fadeIn('right', 0.7)}
                  initial="hidden"
                  whileInView={'show'}
                  viewport={{ once: true, amount: 0.7 }}
                  className='bg-black/50 backdrop-blur-2xl p-4 rounded flex flex-col items-left'>
                  <div className='text-left flex-1 flex-col'>
                    <Typography variant="h6" component="span">
                      Software Engineer
                    </Typography>
                    <Typography>Honeysuckle Health (nib Group) <br /> - Brisbane, Australia </Typography>
                  </div>
                  <div className='bg-about flex flex-col items-start justify-between h-full'>
                    <Typography className='pb-4'>Nov 2025 - May 2026</Typography>
                    <img src={Logo_HH_nib} alt="Honeysuckle Health" className='w-[240px] bg-[#fdf1fc] rounded-xl p-2' />
                  </div>
                </motion.div>
              </TimelineContent>
            </TimelineItem>

            <TimelineItem>
              <TimelineSeparator>
                <TimelineConnector />
                <TimelineDot color="primary">
                  <FaGraduationCap />
                </TimelineDot>
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent sx={{ py: '12px', px: 2 }}>
                <motion.div
                  variants={fadeIn('right', 0.7)}
                  initial="hidden"
                  whileInView={'show'}
                  viewport={{ once: true, amount: 0.7 }}
                  className='bg-black/50 backdrop-blur-2xl p-4 rounded flex flex-col items-left'>
                  <div className='text-left flex-1 flex-col'>
                    <Typography variant="h6" component="span">
                      Masters of Information Technology
                    </Typography>
                    <Typography>Queensland University of Technology (QUT) <br /> - Brisbane, Australia</Typography>
                  </div>
                  <div className='bg-about flex items-end justify-between h-full'>
                    <Typography>Jul 2023 - Jul 2025 (Graduated)</Typography>
                    <img src={Logo_QUT} alt="QIU" className='w-[70px]' />
                  </div>
                </motion.div>
              </TimelineContent>
            </TimelineItem>

            <TimelineItem>
              <TimelineSeparator>
                <TimelineConnector />
                <TimelineDot color="secondary" >
                  <BiBriefcase />
                </TimelineDot>
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent sx={{ py: '12px', px: 2 }}>
                <motion.div
                  variants={fadeIn('right', 0.7)}
                  initial="hidden"
                  whileInView={'show'}
                  viewport={{ once: true, amount: 0.7 }}
                  className='bg-black/50 backdrop-blur-2xl p-4 rounded flex flex-col items-left'>
                  <div className='text-left flex-1 flex-col'>
                    <Typography variant="h6" component="span">
                      Senior Front-End Developer
                    </Typography>
                    <Typography>Nexmind AI - Malaysia</Typography>
                  </div>
                  <div className='bg-about flex items-end justify-between h-full'>
                    <Typography>Mar 2023 - Aug 2023</Typography>
                    <img src={Logo_Nexmind} alt="QIU" className='w-[50px] mr-2' />
                  </div>
                </motion.div>
              </TimelineContent>
            </TimelineItem>

            <TimelineItem>
              <TimelineSeparator>
                <TimelineConnector />
                <TimelineDot color="secondary">
                  <BiBriefcase />
                </TimelineDot>
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent sx={{ py: '12px', px: 2 }}>
                <motion.div
                  variants={fadeIn('right', 0.7)}
                  initial="hidden"
                  whileInView={'show'}
                  viewport={{ once: true, amount: 0.7 }}
                  className='bg-black/50 backdrop-blur-2xl p-4 rounded flex flex-col items-left'>
                  <div className='text-left flex-1 flex-col'>
                    <Typography variant="h6" component="span">
                      Front-End Web Developer
                    </Typography>
                    <Typography>EasyStore - Malaysia</Typography>
                  </div>
                  <div className='bg-about flex items-end justify-between h-full'>
                    <Typography>May 2021 - Nov 2022</Typography>
                    <img src={Logo_EasyStore} alt="QIU" className='w-[70px]' />
                  </div>
                </motion.div>
              </TimelineContent>
            </TimelineItem>

            <TimelineItem>
              <TimelineSeparator>
                <TimelineConnector />
                <TimelineDot color="secondary" >
                  <BiBriefcase />
                </TimelineDot>
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent sx={{ py: '12px', px: 2 }}>
                <motion.div
                  variants={fadeIn('right', 0.7)}
                  initial="hidden"
                  whileInView={'show'}
                  viewport={{ once: true, amount: 0.7 }}
                  className='bg-black/50 backdrop-blur-2xl p-4 pr-6 rounded flex flex-col items-left'>
                  <div className='text-left flex-1 flex-col'>
                    <Typography variant="h6" component="span">
                      Front-End Web Developer (Freelance)
                    </Typography>
                    <Typography>IOT Advance - Malaysia</Typography>
                  </div>
                  <div className='bg-about flex items-end justify-between h-full'>
                    <Typography>Mar 2021 - Feb 2022</Typography>
                    <img src={Logo_Iot} alt="QIU" className='w-[80px]' />
                  </div>
                </motion.div>
              </TimelineContent>
            </TimelineItem>

            <TimelineItem>
              <TimelineSeparator>
                <TimelineConnector />
                <TimelineDot color="secondary">
                  <BiBriefcase />
                </TimelineDot>
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent sx={{ py: '12px', px: 2 }}>
                <motion.div
                  variants={fadeIn('right', 0.7)}
                  initial="hidden"
                  whileInView={'show'}
                  viewport={{ once: true, amount: 0.7 }}
                  className='bg-black/50 backdrop-blur-2xl p-4 rounded flex flex-col items-left'>
                  <div className='text-left flex-1 flex-col'>
                    <Typography variant="h6" component="span">
                      Web Developer
                    </Typography>
                    <Typography>Enterprise 73 - Malaysia</Typography>
                  </div>
                  <div className='bg-about flex items-end justify-between h-full'>
                    <Typography>Dec 2019 - Dec 2020</Typography>
                    <img src={Logo_E73} alt="QIU" className='w-[150px]' />
                  </div>
                </motion.div>
              </TimelineContent>
            </TimelineItem>
            <TimelineItem>
              <TimelineSeparator>
                <TimelineConnector />
                <TimelineDot color="primary">
                  <FaGraduationCap />
                </TimelineDot>
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent sx={{ py: '12px', px: 2 }}>
                <motion.div
                  variants={fadeIn('right', 0.7)}
                  initial="hidden"
                  whileInView={'show'}
                  viewport={{ once: true, amount: 0.7 }}
                  className='bg-black/50 backdrop-blur-2xl p-4 rounded flex flex-col items-left'>
                  <div className='text-left flex-1 flex-col'>
                    <Typography variant="h6" component="span">
                      Bachelor in Computer Science (HONs)
                    </Typography>
                    <Typography>Quest International University (QIU) - Malaysia</Typography>
                  </div>
                  <div className='bg-about flex items-end justify-between h-full'>
                    <Typography>2015 - 2019</Typography>
                    <img src={Logo_QIU} alt="QIU" className='w-[50px] rounded' />
                  </div>
                </motion.div>
              </TimelineContent>
            </TimelineItem>

          </Timeline>
        </motion.div>
      </div>
    </section>
  )
}

export default Work
